import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BlogService {

    constructor(private http: HttpClient) { }

    /**
     * Get all posts
     */
    index() {
        return this.http.get<any>('api_endpoint' + '/blog/index');
    }
}
